const messages = {
  insuranceCapture: {
    opener1: () => {
      return "Great—that should cover it."
    },
    opener2: () => {
      return "I have a few next steps in mind, and may be able to customize them based on your insurance."
    },
  },
  employerCapture: {
    opener1: () => {
      return "I'm about to suggest some next steps to get you feeling better, including whether to see a doctor."
    },
    opener2: () => {
      return "If you get health insurance through your job or a family member's job, I may be able to show you customized suggestions based on your insurance."
    },
    optOut: () => {
      return "Not a problem – I can still suggest next steps."
    },
    closer: (isMatch) => {
      if (isMatch) {
        return "Great! This employer is part of the Buoy network. In addition to potential next steps, I'll tell you which services are covered by your insurance."
      }
      return "Got it. This employer isn't part of our network, but I can still suggest next steps. Let's get you feeling better."
    },
  },
}

export { messages as default }



// WEBPACK FOOTER //
// ./assets/integration/messages.js